<template>
  <v-dialog
    v-model="computedSnowmakingImagesVisibility"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-card tile>
      <v-toolbar card>
        <!-- close icon -->
        <v-btn
          icon
          @click="
            methodToggleSingleLayer('snowmaking', 'images', false);
            date = null;
            base64image = null;
            disable_edit = true;
          "
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span>{{ computedName }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            @click="
              zoomTo({
                center: computedLatLng[0].geometry.coordinates,
                level: 18
              });
              // check if map layer is visible, toggle on if not so when we zoom to location
              // there is a dot to zoom to
              methodCloseListLayer('snowmaking', 'images');
              methodToggleSingleLayer('snowmaking', 'images', false);
            "
          >
            <v-icon>map</v-icon>
          </v-btn>
          <span>See on map</span>
        </v-tooltip>
        <!-- delete icon -->
        <v-tooltip bottom>
          <v-btn
            icon
            slot="activator"
            :disabled="disable_edit"
            @click="confirm_delete = true"
          >
            <v-icon>delete</v-icon>
          </v-btn>
          <span>Delete</span>
        </v-tooltip>

        <!-- edit icon -->
        <v-tooltip bottom>
          <v-btn
            :color="disable_edit ? '' : 'primary'"
            icon
            slot="activator"
            :disabled="computedAuthProfile != 'maintenance'"
            @click="
              disable_edit = !disable_edit;
              base64image = null;
            "
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <span>Edit</span>
        </v-tooltip>
      </v-toolbar>
      <div
        style="background-color: black; padding-left: 30px; overflow:auto; -webkit-overflow-scrolling:touch;"
      >
        <v-data-table
          :items="computedSnowmakingImagesGeoJsonFeature"
          :loading="computedSnowmakingImagessLoading"
          :hide-actions="hideactions"
          :hide-headers="hideheaders"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td colspan="2">
                <span
                  v-if="
                    computedImageUrl !=
                      'https://api2.alchemymapping.com/images/null'
                  "
                >
                  <img
                    style="max-height: 90vh; max-width: 90vw;"
                    :src="computedImageUrl"
                  />
                </span>
              </td>
            </tr>
            <tr v-if="!disable_edit">
              <td>Update Image</td>
              <td>
                <image-uploader
                  @input="methodSetOutput"
                  :quality="0.7"
                  :autoRotate="attemptAutoRotate"
                  outputFormat="base64"
                  class="fileinput2"
                  :preview="true"
                  accept=".jpg"
                  :key="attemptAutoRotate"
                />
              </td>
            </tr>
            <tr v-if="!disable_edit">
              <td>EXIF rotate?</td>
              <td><v-checkbox v-model="attemptAutoRotate" class="mt-2" /></td>
            </tr>
            <tr>
              <td>Category</td>
              <td>
                <v-select
                  ref="ref_category"
                  v-model="props.item.properties.category"
                  :disabled="disable_edit"
                  :items="opt_category"
                ></v-select>
              </td>
            </tr>
            <tr>
              <td>Title</td>
              <td>
                <v-text-field
                  ref="ref_title"
                  v-model="props.item.properties.title"
                  :disabled="disable_edit"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td>
                <v-textarea
                  ref="ref_description"
                  v-model="props.item.properties.description"
                  :disabled="disable_edit"
                ></v-textarea>
              </td>
            </tr>
            <tr>
              <td>Date</td>
              <td>
                {{ props.item.properties.created.split("T")[0] }}
              </td>
            </tr>
            <tr>
              <td>Created by</td>
              <td>
                {{ props.item.properties.created_by }}
              </td>
            </tr>
          </template>
          <template slot="footer">
            <tr>
              <td colspan="100%">
                <v-spacer class="hidden-sm-and-down"></v-spacer>
                <v-btn
                  v-if="base64image"
                  @click.stop="
                    methodEditImageSnowmakingImagesGeoJson({
                      title: $refs.ref_title.value,
                      category: $refs.ref_category.value,
                      description: $refs.ref_description.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('snowmaking', 'images', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >
                <v-btn
                  v-else
                  @click.stop="
                    methodEditSnowmakingImagesGeoJson({
                      title: $refs.ref_title.value,
                      category: $refs.ref_category.value,
                      description: $refs.ref_description.value
                    });
                    disable_edit = true;
                    methodToggleSingleLayer('snowmaking', 'images', false);
                  "
                  :disabled="disable_edit"
                  color="success"
                  >Save</v-btn
                >

                <v-spacer class="hidden-sm-and-down"></v-spacer>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    <!-- Delete confirmation dialog -->
    <v-dialog v-model="confirm_delete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>Are you sure? This is permanent.</span>
        </v-card-title>
        <v-card-actions>
          <!-- confirm delete button -->
          <v-btn
            color="error"
            flat
            @click.stop="
              confirm_delete = false;
              disable_edit = true;
              methodDeleteSnowmakingImagesGeoJson();
              methodToggleSingleLayer('snowmaking', 'images', false);
            "
            >Delete</v-btn
          >
          <!-- Cancel button -->
          <v-btn color="primary" flat @click.stop="confirm_delete = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<style scoped>
table {
  padding-top: 20px;
}
</style>
<script>
export default {
  data() {
    return {
      base64image: null,
      attemptAutoRotate: false,
      disable_edit: true,
      confirm_delete: false,
      loading: true,
      persistent: false,
      hideheaders: true,
      hideactions: true,
      solo: true,
      opt_category: [
        { text: "Underground" },
        { text: "Maintenance" },
        { text: "Operations" },
        { text: "Default" }
      ]
    };
  },
  computed: {
    computedLatLng() {
      if (this.computedSnowmakingImagesVisibility) {
        const images = this.$store.state.mapLayers.snowmaking.layers.images
          .geojson.features;
        const result = images.filter(
          item => item.properties.id == this.computedSnowmakingImagesId
        );
        return result;
      }
      return [];
    },
    computedName() {
      let res;
      if (
        this.computedSnowmakingImagesVisibility &&
        this.$store.state.mapLayers.snowmaking.layers.images.geojson.features
      ) {
        const points = this.$store.state.mapLayers.snowmaking.layers.images
          .geojson.features;
        // grabs the lift_name of the currently viewed ID
        let result = points.filter(
          item => item.properties.id == this.computedSnowmakingImagesId
        );
        res = result[0].properties.title;
      }
      return res;
    },
    computedSnowmakingImagesGeoJsonFeature() {
      let res;
      if (
        this.$store.state.mapLayers.snowmaking.layers.images.geojson.features
      ) {
        const points = this.$store.state.mapLayers.snowmaking.layers.images
          .geojson.features;
        const result = points.filter(
          item => item.properties.id == this.computedSnowmakingImagesId
        );
        res = result;
      }
      return res;
    },
    computedSnowmakingImagesVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.images.visibility
        .singleView;
    },
    computedSnowmakingImagessLoading() {
      return this.$store.state.mapLayers.snowmaking.layers.images.loading;
    },
    computedSnowmakingImagesId() {
      return this.$store.state.mapLayers.snowmaking.layers.images.visibility
        .singleId;
    },
    computedImageUrl() {
      console.log("imageUrl");
      if (
        this.$store.state.ui.image &&
        this.$store.state.ui.image.filename &&
        this.$store.state.ui.image.filename.filename &&
        this.$store.state.ui.image.filename.filename.filename
      ) {
        console.log("inside if");
        return (
          "https://api2.alchemymapping.com/images/" +
          this.$store.state.ui.image.filename.filename.filename
        );
      } else {
        console.log("inside else");
        return "https://api2.alchemymapping.com/images/null";
      }
    },
    computedImageHack() {
      return this.$store.state.ui.image.filename.filename.filename;
    },
    computedAuth() {
      return this.$store.state.auth;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    }
  },
  methods: {
    methodSetOutput(file) {
      this.base64image = file;
    },
    methodCloseListLayer(dept, layer) {
      this.$store.commit("mutationCloseListLayer", {
        dept: dept,
        layer: layer
      });
    },
    getNormalDate(utcdate) {
      // utc date is a string like 2018-04-16T21:52:58.811Z
      let date = new Date(utcdate);
      let y = date.getFullYear();
      let m = date.getMonth();
      let d = date.getDay();
      return y + "-" + m + "-" + d;
    },
    // method to get geojson
    methodGetSnowmakingImagesGeoJson() {
      this.$store.dispatch("actionGetGeoJson", {
        url: "https://api2.alchemymapping.com/vail/whistler/snowmaking/images",
        dept: "snowmaking",
        layer: "images",
        token: this.computedAuthToken
      });
    },
    methodEditSnowmakingImagesGeoJson(data) {
      this.$store.dispatch("actionEditGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/images/" +
          this.computedSnowmakingImagesId,
        dept: "snowmaking",
        layer: "images",
        token: this.computedAuthToken,
        payload: data
      });
    },
    methodEditImageSnowmakingImagesGeoJson(data) {
      this.$store
        .dispatch("actionEditJsonImage", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/images/" +
            this.computedSnowmakingImagesId,
          imageUrl:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/images/image",
          base64data: this.base64image,
          dept: "snowmaking",
          layer: "images",
          token: this.computedAuthToken,
          payload: data,
          belongstoid: this.computedSnowmakingImagesId
        })
        .then(() => {
          this.base64image = null;
        });
    },
    methodDeleteSnowmakingImagesGeoJson() {
      this.$store
        .dispatch("actionDeleteGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/images/" +
            this.computedSnowmakingImagesId,
          dept: "snowmaking",
          layer: "images",
          token: this.computedAuthToken
        })
        .then(
          setTimeout(() => {
            this.methodGetSnowmakingImagesGeoJson();
          }, 250)
        );
    },
    methodGetSnowmakingImage() {
      this.$store.dispatch("actionGetImage", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/images/image/" +
          this.computedSnowmakingImagesId,
        token: this.computedAuthToken
      });
    }
  },
  watch: {
    // watches the visibility of the list view, and if visible, calls action to get geojson.
    "$store.state.mapLayers.snowmaking.layers.images.visibility.singleView": function(
      newValue
    ) {
      if (newValue) {
        this.methodGetSnowmakingImagesGeoJson();
        this.methodGetSnowmakingImage();
      }
    },
    // after data is loaded, set loading = false to stop loading progress indicator
    "$store.state.mapLayers.snowmaking.layers.images.geojson": function(
      newValue
    ) {
      if (newValue) {
        this.loading = false;
      }
    }
  }
};
</script>
